export default __webpack_public_path__ + "static/media/BrianGarageRock2019-Ver6.8af675e0.mp3";